import React, { useState, useEffect } from 'react'
import { View, Image, Text, TouchableOpacity, StyleSheet, Alert, PixelRatio, Platform, StatusBar } from 'react-native'
import { Ionicons, Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import EditProfileScreen from './EditProfileScreen'
import styles from './ProfileHeaderStyles'
import { placeholderGeneral } from '../customUtils/Constants'
import { avatarPlaceholder, getAvatarPlaceholderLocal } from '../customUtils/Constants'
import { safeImageSource } from '../../utils/imageUtils'
import { getAppVersion } from '../customUtils/AppConstants'
import { TEST, apiUrl } from '../../config/config'
import { getLanguage } from '../appBar/context/LocalizationContext'
import * as ImagePicker from 'expo-image-picker'
import * as FileSystem from '../../utils/fileSystemCompat'
import { getCurrentUser } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import { uploadData } from 'aws-amplify/storage'
import { manipulateAsync, FlipType, SaveFormat } from 'expo-image-manipulator'
import { getImageStogeUrl, uploadImage } from '../imageUploader/ImageStorage'
import NetInfo from '@react-native-community/netinfo'
import { isEntornoTesting } from '../../utils/functions.utils'
import { UserServices } from '../../../database/user.database'
import { request_edit_user_profile } from '../../services/user.services'

export default function ProfileHeader({ avatar, fullName, user, version, onClickEdit, activeButtonDeleted, onClickDelete, onClickChangePassword }) {
    const { openBottomSheet } = useBottomSheet()
    const [user_data, setUser] = useState(user)
    const { languageFile } = getLanguage()
    const [photoURL, setPhotoURL] = useState(avatar)
    const [selectedImage, setSelectedImage] = useState(null)
    const [languages, setLanguages] = useState(user_data?.languages ?? [])
    useEffect(() => {
        setPhotoURL(avatar)
    }, [avatar])
    const fontScale = 1
    const iconSize = 24 * fontScale

    useEffect(() => {
        if (user) {
            const updatedUser = { ...user, avatar: avatar }
            setUser(updatedUser)
        }
    }, [user])

    const onSaveEditProfile = (new_data) => {
        console.log('🚀 ~ llegaaa ~ new_data:', new_data)
        if (new_data) {
            setUser(new_data)
        }
        openBottomSheet(null) // Cierra el modal al guardar los cambios
    }

    const handle_edit_profile = () => {
        console.log('handle_edit_profile')
        if (!user_data) {
            return
        }
        const snapPoints = ['80%']
        openBottomSheet(
            <EditProfileScreen
                user_data={user_data}
                avatar={user_data?.avatar}
                onSave={onSaveEditProfile}
                activeButtonDeleted={activeButtonDeleted}
                onClickDelete={onClickDelete}
            />,
            snapPoints,
        )
    }

    const editPhoto = async () => {
        console.log('[ProfileHeader] editPhoto called')
        try {
            // revisar esto por problemas con los mensajes que tiene iOS para hacer el ipa //
            const cameraPermissionResult = await ImagePicker.requestCameraPermissionsAsync()
            const mediaLibraryPermissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()

            if (cameraPermissionResult.granted === false || mediaLibraryPermissionResult.granted === false) {
                Alert.alert(languageFile.insufficient_permissions, languageFile.permissions_to_access)
                return
            }

            let mediaTypesChoice
            if (Platform.OS === 'web') {
                // On web, expo-image-picker uses MediaType strings/arrays; use a safe default
                mediaTypesChoice = ['images']
            } else {
                // Prefer MediaTypeOptions (exported) and avoid referencing MediaType (not exported on web builds)
                mediaTypesChoice = (ImagePicker && ImagePicker.MediaTypeOptions && ImagePicker.MediaTypeOptions.Images) || undefined
            }

            const options = {
                allowsEditing: true,
                aspect: [1, 1],
                quality: 0.5, // Aumentar un poco la calidad para el preview
                ...(mediaTypesChoice ? { mediaTypes: mediaTypesChoice } : {}),
                presentationStyle: ImagePicker.UIImagePickerPresentationStyle.FULL_SCREEN,
                allowsMultipleSelection: false,
                exif: false,
            }

            Alert.alert(
                languageFile.choose_font,
                languageFile.select_the_image,
                [
                    {
                        text: languageFile.camera,
                        onPress: async () => {
                            // Forzar StatusBar claro antes de abrir el picker
                            if (Platform.OS === 'android') {
                                StatusBar.setBarStyle('dark-content')
                                StatusBar.setBackgroundColor('#ffffff')
                            }
                            // Pequeño delay para que el Alert se cierre completamente
                            setTimeout(async () => {
                                const pickerResult = await ImagePicker.launchCameraAsync(options)
                                await handleImagePickerResult(pickerResult)
                                // Restaurar StatusBar después
                                if (Platform.OS === 'android') {
                                    StatusBar.setBarStyle('dark-content')
                                }
                            }, 300)
                        },
                    },
                    {
                        text: languageFile.gallery,
                        onPress: async () => {
                            // Forzar StatusBar claro antes de abrir el picker
                            if (Platform.OS === 'android') {
                                StatusBar.setBarStyle('dark-content')
                                StatusBar.setBackgroundColor('#ffffff')
                            }
                            // Pequeño delay para que el Alert se cierre completamente
                            setTimeout(async () => {
                                const pickerResult = await ImagePicker.launchImageLibraryAsync(options)
                                await handleImagePickerResult(pickerResult)
                                // Restaurar StatusBar después
                                if (Platform.OS === 'android') {
                                    StatusBar.setBarStyle('dark-content')
                                }
                            }, 300)
                        },
                    },
                ],
                { cancelable: true },
            )
        } catch (err) {
            console.error('[ProfileHeader] editPhoto top-level error:', err)
            Alert.alert('Error', 'No se pudo abrir la cámara/galería. Reintente.')
        }
    }

    const handleImagePickerResult = async (pickerResult) => {
        console.log('🚀 ~ editPhoto ~ pickerResult:', pickerResult)

        if (!pickerResult.cancelled && !(pickerResult.assets && pickerResult.assets.length === 0)) {
            try {
                // Obtener URI (nueva forma assets[])
                let imageUri = pickerResult.uri
                if (pickerResult.assets && pickerResult.assets.length > 0) imageUri = pickerResult.assets[0].uri

                console.log('ProfileHeader editPhoto pickerResult uri:', imageUri)

                // Obtener Blob: en Android fetch(file://...) funciona; en iOS/Expo fetch(file://...) falla.
                let blob
                if (Platform.OS === 'android') {
                    // En Android podemos hacer fetch directo del archivo local
                    const resp = await fetch(imageUri)
                    blob = await resp.blob()
                } else {
                    // En iOS/Expo leemos en base64 y convertimos via dataURL+fetch
                    const encodingBase64 = (FileSystem && FileSystem.EncodingType && FileSystem.EncodingType.Base64) || 'base64'
                    const base64 = await FileSystem.readAsStringAsync(imageUri, { encoding: encodingBase64 })
                    console.log('[ProfileHeader] read base64 length:', base64?.length)
                    const dataUrl = `data:image/jpeg;base64,${base64}`
                    const resp = await fetch(dataUrl)
                    blob = await resp.blob()
                }

                const timestamp = Date.now()
                const filename = `avatars/profile-${user_data._id}-${timestamp}.jpg`
                const thumbnailFilename = `avatars/profile-thumbnail-${user_data._id}-${timestamp}.jpg`
                let sube
                try {
                    sube = await uploadData({
                        key: filename,
                        data: blob,
                        options: {
                            contentType: 'image/jpeg',
                        },
                    }).result
                    console.log('[ProfileHeader] uploadData result:', sube)
                } catch (uploadErr) {
                    console.error('[ProfileHeader] uploadData failed:', uploadErr)
                    try {
                        console.log('[ProfileHeader] attempting fallback uploadImage for filename:', filename)
                        const fallbackOk = await uploadImage(filename, imageUri)
                        console.log('[ProfileHeader] fallback uploadImage result:', fallbackOk)
                        if (!fallbackOk) throw new Error('Fallback uploadImage failed')
                    } catch (fbErr) {
                        console.error('[ProfileHeader] fallback uploadImage also failed:', fbErr)
                        throw fbErr
                    }
                }

                const imageUrl = await getImageStogeUrl(filename)
                setPhotoURL(imageUrl)
                setSelectedImage({ avatar: filename, thumbnail: thumbnailFilename })

                // Crear una versión miniatura de la imagen con menor calidad y resolución
                const thumbnailOptions = {
                    compress: 0.5, // Comprimir la imagen a la mitad
                    format: 'jpeg', // Formato JPEG
                    base64: false, // No devolver en base64
                    width: 100, // Ancho de la imagen
                    height: 100, // Alto de la imagen
                }
                const thumbnailResult = await manipulateAsync(imageUri, [{ resize: thumbnailOptions }], {
                    compress: 0.5,
                    format: 'jpeg',
                    base64: false,
                })
                // Convertir thumbnail a blob: en Android usar fetch directo, en iOS usar base64->dataURL
                let thumbnailBlob
                if (Platform.OS === 'android') {
                    const thumbnailResp = await fetch(thumbnailResult.uri)
                    thumbnailBlob = await thumbnailResp.blob()
                } else {
                    const encodingBase64Thumb = (FileSystem && FileSystem.EncodingType && FileSystem.EncodingType.Base64) || 'base64'
                    const thumbnailBase64 = await FileSystem.readAsStringAsync(thumbnailResult.uri, { encoding: encodingBase64Thumb })
                    try {
                        const thumbnailDataUrl = `data:image/jpeg;base64,${thumbnailBase64}`
                        const tResp = await fetch(thumbnailDataUrl)
                        thumbnailBlob = await tResp.blob()
                    } catch (tConvErr) {
                        console.warn('[ProfileHeader] failed to convert thumbnail base64 to blob via fetch:', tConvErr)
                        const thumbnailByteCharacters = atob(thumbnailBase64)
                        const thumbnailByteNumbers = new Array(thumbnailByteCharacters.length)
                        for (let i = 0; i < thumbnailByteCharacters.length; i++) {
                            thumbnailByteNumbers[i] = thumbnailByteCharacters.charCodeAt(i)
                        }
                        const thumbnailByteArray = new Uint8Array(thumbnailByteNumbers)
                        thumbnailBlob = new Blob([thumbnailByteArray], { type: 'image/jpeg' })
                    }
                }

                const thumbnailSube = await uploadData({
                    key: thumbnailFilename,
                    data: thumbnailBlob,
                    options: {
                        contentType: 'image/jpeg',
                    },
                }).result
                const thumbnailImageUrl = await getImageStogeUrl(thumbnailFilename)
                // Editar perfil
                await updateProfile(filename, thumbnailFilename)

                // console.log('🚀 ~ thumbnailImageUrl:', thumbnailImageUrl)
            } catch (error) {
                console.error('Error al subir la imagen:', error)
            }
        }
    }
    const updateProfile = async (avatarImage, avatarThumbnail) => {
        try {
            const authToken = await getAuthToken()
            if (!authToken) {
                console.error('❌ No hay token de autenticación')
                return
            }

            const netInfoState = await NetInfo.fetch()
            let data

            if (netInfoState.isConnected) {
                const editedData = {
                    avatar_image: avatarImage,
                    avatar_image_thumbnail: avatarThumbnail,
                }

                // const response = await fetch(`${apiUrl}/edit_user_profile`, {
                //     method: 'POST',
                //     headers: {
                //         'Content-Type': 'application/json',
                //         Authorization: authToken,
                //     },
                //     body: JSON.stringify({
                //         user_data: editedData,
                //     }),
                // })

                // if (!response.ok) {
                //     throw new Error('Fallo al actualizar el usuario en el servidor')
                // }

                data = await request_edit_user_profile(authToken, editedData)
                console.log('✅ Respuesta del servidor:', data)
            } else {
                console.log('⚠️ Sin conexión, guardando localmente')
                data = {
                    status: 0,
                }
            }

            if (data?.status === 1) {
                console.log('💾 Guardando usuario actualizado en BD local...')

                try {
                    // Obtener identificador Cognito
                    let cognitoId = null
                    try {
                        const currentUser = await getCurrentUser()
                        cognitoId = currentUser?.attributes?.sub || currentUser?.username || null
                    } catch (e) {
                        console.warn('⚠️ No se pudo obtener Cognito ID:', e)
                        cognitoId = null
                    }

                    // Preparar datos del usuario para guardar
                    const user_data = {
                        ...data.single.user_data,
                        _id: data.single.user_data._id, // Asegurar que tiene _id
                        delete_active: data.single.delete_active,
                        languages: languages,
                        login: true,
                        cognito_id: cognitoId,
                        // Asegurar que los campos de avatar se guarden correctamente
                        avatar: avatarImage,
                        avatar_image: avatarImage,
                        avatar_image_thumbnail: avatarThumbnail,
                    }

                    // ✅ Usar el servicio de usuario (importado estáticamente)
                    console.log('📝 Llamando a UserServices.upsertUser...')
                    await UserServices.upsertUser(user_data)
                    console.log('✅ Usuario guardado en base de datos local')

                    // Actualizar el estado local
                    console.log('📝 Actualizando estado local del usuario...')
                    data.single.user_data.avatar = avatarImage
                    data.single.user_data.avatar_image = avatarImage
                    data.single.user_data.avatar_image_thumbnail = avatarThumbnail

                    let dataSave = {
                        ...data.single.user_data,
                        languages: languages,
                        delete_active: data.single.delete_active ?? false,
                        // Asegurar que user_segment esté en el formato correcto
                        user_segment: data.single.user_data.user_segment || {},
                    }

                    // ✅ Actualizar la URL de la foto localmente
                    console.log('📝 Obteniendo nueva URL de imagen...')
                    const newPhotoURL = await getImageStogeUrl(avatarImage)
                    console.log('📝 Nueva URL obtenida, actualizando photoURL...')
                    setPhotoURL(newPhotoURL)

                    // ✅ Actualizar el estado del usuario
                    console.log('📝 Actualizando estado del componente con setUser...')
                    setUser(dataSave)
                    console.log('✅ Perfil actualizado completamente')

                    // ✅ Mostrar confirmación al usuario (con setTimeout para evitar problemas)
                    console.log('📝 Mostrando alerta de éxito...')
                    setTimeout(() => {
                        Alert.alert('Éxito', 'Tu foto de perfil se ha actualizado correctamente')
                    }, 100)
                } catch (dbError) {
                    console.error('❌ Error al guardar en base de datos local:', dbError)
                    Alert.alert('Error', 'No se pudo guardar la foto en la base de datos local')
                    // No lanzar error aquí para permitir que el proceso continúe
                }
            } else {
                console.log('⚠️ Actualización del servidor no fue exitosa, status:', data?.status)
                Alert.alert('Error', 'No se pudo actualizar la foto en el servidor')
            }
        } catch (error) {
            console.error('❌ Error al actualizar el perfil:', error)
            Alert.alert('Error', 'No se pudo actualizar el avatar. Por favor, inténtalo nuevamente.')
        }
    }

    const isEntornoTest = isEntornoTesting()

    return (
        <View style={styles.container}>
            <TouchableOpacity style={[styles.containerAvatar]} onPress={() => editPhoto()}>
                <Image
                    style={[styles.avatar, { resizeMode: 'cover' }]}
                    source={safeImageSource(photoURL, Platform.OS === 'web' ? avatarPlaceholder : getAvatarPlaceholderLocal())}
                />
                <View style={styles.containerIcon}>
                    <Ionicons name='add-circle' size={iconSize} color={theme.colors.colorPrimary} style={styles.icon} />
                </View>
            </TouchableOpacity>

            <View style={styles.dataBlock}>
                <Text style={styles.name}>{user_data?.name + ' ' + user_data?.last_name}</Text>
                <Text style={styles.user}>{user_data?.email && user_data?.email != 'a@a.com' ? user_data?.email : ''}</Text>
                {user_data?.nickname && user_data?.nickname !== '' && <Text style={styles.user}>{user_data?.nickname}</Text>}

                <TouchableOpacity
                    onPress={() => {
                        onClickChangePassword()
                    }}
                >
                    <Text
                        style={[
                            {
                                color: theme.colors.colorPrimary,
                                fontWeight: 'bold',
                                marginTop: 5,
                                fontSize: 13,
                            },
                        ]}
                    >
                        {'Cambiar contraseña'}
                    </Text>
                </TouchableOpacity>
                {apiUrl.includes(TEST) && <Text style={styles.version}>{'Entorno Test'}</Text>}
            </View>

            {/* <TouchableOpacity onPress={() => handle_edit_profile()} style={styles.editIcon}>
                <Feather name='edit-2' size={18} color={theme.colors.colorPrimary} />
            </TouchableOpacity> */}
        </View>
    )
}
